import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function JoinRoom() {
  const { roomId } = useParams();
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation('join');

  const handleJoin = () => {
    if (!password.trim()) {
      alert(t('errors.emptyPassword'));
      return;
    }
    navigate(`/chat/${roomId}`, { state: { password } });
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h2 style={styles.title}>{t('title')}</h2>
        <div style={styles.separator} />
        <p style={styles.roomId}>{t('roomId')}: {roomId}</p>

        <input
          type="password"
          placeholder={t('passwordPlaceholder')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          onKeyPress={(e) => e.key === 'Enter' && handleJoin()}
        />

        <button 
          onClick={handleJoin} 
          style={styles.button}
        >
          {t('joinButton')}
        </button>

        <button 
          onClick={() => navigate(-1)} 
          style={styles.backButton}
        >
          {t('backButton')}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    padding: '2rem',
  },
  content: {
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#000',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    marginBottom: '1rem',
  },
  separator: {
    height: '2px',
    width: '60px',
    backgroundColor: '#000',
    margin: '1.5rem auto',
  },
  roomId: {
    fontSize: '1.1rem',
    color: '#666',
    marginBottom: '2rem',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    padding: '1rem',
    marginBottom: '1.5rem',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border-color 0.2s',
    ':focus': {
      borderColor: '#000',
    },
  },
  button: {
    width: '100%',
    padding: '1rem',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    marginBottom: '1rem',
    ':hover': {
      opacity: 0.9,
    },
  },
  backButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#666',
    cursor: 'pointer',
    fontSize: '0.9rem',
    ':hover': {
      color: '#000',
    },
  },
};

export default JoinRoom;